<template>
  <div class="col-12 shippingform">
    <div class="row">
      <div class="col-md-2 col-6 order-md-1">{{$t('shopping.contact')}}</div>
      <div class="col-md-2  col-6 order-md-3 ml-auto text-right">
        <a :href="this.replaceSearch('step','contact_information')">{{$t('shopping.change')}}</a>
      </div>
      <div class="col-md-8 order-2">{{user? user.user_email:cart.address.email}}</div>
    </div>
    <div class="row">
      <div class="col-md-2 col-6 order-md-1">{{$t('shopping.ship_to')}}</div>
      <div class="col-md-2 col-6 order-md-3 ml-auto text-right">
        <a :href="this.replaceSearch('step','contact_information')">{{$t('shopping.change')}}</a>
      </div>
      <div class="col-md-8 order-2" style="word-break:break-word;">
        {{cart.address.address_1}} {{cart.address.address_2}} {{cart.address.city}}, {{cart.address.postcode}} 
        <span
          v-if="this.getstate(cart.address.state,cart.address.country,service)"
          v-html="this.getstate(cart.address.state,cart.address.country,service)"
        ></span>
        <span v-else>{{cart.address.state}} </span>
        <span v-html="this.getcountry(cart.address.country,service)"></span>
      </div>
    </div>
    <div class="row" v-if="method">
      <div class="col-md-2 col-6 order-md-1">{{$t('shopping.method')}}</div>
      <div class="col-md-2 col-6 order-md-3 ml-auto text-right">
        <a :href="this.replaceSearch('step','shipping_method')">{{$t('shopping.change')}}</a>
      </div>
      <div class="col-md-8 order-2"> <span v-html="method.label"></span> ·  <span style="font-weight:600;"><v-currencysymbol></v-currencysymbol>{{method.cost}}</span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["method", "user", "cart", "service"],
  data() {
    return {
      cart_hash: window.location.pathname,
    };
  },
  beforeMount(){
    console.log('this.cart_hash',this.cart_hash);
  }
};
</script>
<style scoped lang='scss'>
.shippingform {
  padding: 12px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  & > div:not(:first-child) {
    padding-top: 12px;
    margin-top: 12px;
    border-top: 1px solid #d9d9d9;
  }
  & > .row {
    margin: 0;
    font-size: 14px;
    div:nth-child(1) {
      color: #737373;
    }
    div:nth-child(2) {
      font-size: 12px;
      a {
        text-decoration: none;
        color: #0f88a7;
      }
    }
    div:nth-child(3) {
      color: #333;
    }
  }

  div {
    padding: 0;
  }
}
</style>